import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FilterCriteria } from 'components/page/index';
import Enums from 'utils/EnumsManager';
import { toggleRightSider } from 'components/page/RightSider/flow/action';
import { setWidth, resetWidth } from 'components/page/EnhancedSider/flow/actions';
import {
  setCriteriaLogic,
  addCriteria,
  removeCriteria,
  updateCriteriaByColumn,
  fetchRightSideData,
  setSiderData,
  resetSiderData,
} from '../flow/action';
import { getConfigByMeta } from '../flow/reselect';
import { formatSiderOptions } from '../utils/criterialUtils';

const { WorkFlow, FieldTypes } = Enums;
const {
  UserInput,
  FunctionName,
  ContextAttributes,
  ApiEndpoint
} = WorkFlow;
const { Lookup, PickList } = FieldTypes;

const defaultProps = {
  logic: '',
  criteria: [],
  metaFields: [],
  rightSiderValue: {},
  conditions: {},
  functionOptions: {}
};
const propTypes = {
  collapsed: PropTypes.bool.isRequired,
  logic: PropTypes.string,
  criteria: PropTypes.array,
  metaFields: PropTypes.array,
  conditions: PropTypes.object,
  functionOptions: PropTypes.object,
  rightSiderValue: PropTypes.object,
  setCriteriaLogic: PropTypes.func.isRequired,
  addCriteria: PropTypes.func.isRequired,
  removeCriteria: PropTypes.func.isRequired,
  updateCriteriaByColumn: PropTypes.func.isRequired,
  toggleRightSider: PropTypes.func.isRequired,
  resetWidth: PropTypes.func.isRequired,
  setWidth: PropTypes.func.isRequired,
  fetchRightSideData: PropTypes.func.isRequired,
  setSiderData: PropTypes.func.isRequired,
  resetSiderData: PropTypes.func.isRequired,
};

class WorkFlowCriteria extends React.Component {
  getValueTypeViaConditions = (fieldId, displayNum) => {
    const { conditions, criteria } = this.props;
    const selectedCriteria = criteria.find(c => c.displayNum === displayNum);
    const selectedCondition = conditions[selectedCriteria.fieldId].find(f => f.id === fieldId);
    return selectedCondition.type;
  }

  getCompareOptions = (fieldId, valueType) => {
    const { functionOptions, metaFields, metaConditions } = this.props;
    switch (valueType) {
      case FunctionName:
        return functionOptions[fieldId];

      case ContextAttributes:
        const selectedFiled = metaFields.find(f => f.id === fieldId);
        if (selectedFiled && selectedFiled.dataType) {
          const fieldRelatedType = metaConditions[selectedFiled.dataType].comparable_crm_data_type;
          if (_.isArray(fieldRelatedType) && !_.isEmpty(fieldRelatedType)) {
            const relatedField = metaFields.filter(f => _.includes(fieldRelatedType, f.dataType));
            return relatedField;
          }
        }
        return [];

      default:
        return [];
    }
  }

  setSider = (filter, selectedField) => {
    const { fetchRightSideData, setSiderData } = this.props;
    if (filter.type === Lookup) {
      const option = selectedField.compareOptions.find(opt => opt.type === ApiEndpoint);
      if (option && option.url) {
        fetchRightSideData(option.url, filter);
      }
    }
    if (filter.type === PickList && _.isArray(selectedField.picklists) && !_.isEmpty(selectedField.picklists)) {
      setSiderData(formatSiderOptions(selectedField.picklists, filter.type), filter);
    }
  }

  handleAddonClick = filter => {
    const {
      metaFields,
      collapsed,
      toggleRightSider,
      setWidth,
      resetSiderData
    } = this.props;
    if (!collapsed) return;
    const selectedField = metaFields.find(f => f.id === filter.fieldId);
    resetSiderData();
    if (!_.isEmpty(selectedField)) {
      this.setSider(filter, selectedField);
    }
    setWidth('right', 300);
    toggleRightSider(false);
  }

  // reset the selective conditon when the field has changed.
  handleFieldChange = (fieldId, displayNum) => {
    const { updateCriteriaByColumn, metaFields } = this.props;
    const selectedField = metaFields.find(f => f.id === fieldId);
    updateCriteriaByColumn('fieldId', displayNum, fieldId);
    updateCriteriaByColumn('type', displayNum, selectedField && selectedField.dataType ? selectedField.dataType : '');
    this.handleConditionChange('', displayNum);
  }

  handleRemove = displayNum => {
    const { removeCriteria, collapsed } = this.props;
    removeCriteria(displayNum);
    if (!collapsed) {
      this.hadleSiderClose();
    }
  }

  // reset the selective valueType when the field has changed.
  handleConditionChange = (fieldId, displayNum) => {
    const { updateCriteriaByColumn } = this.props;
    updateCriteriaByColumn('conditionId', displayNum, fieldId);
    if (!_.isEmpty(fieldId)) {
      const functionType = this.getValueTypeViaConditions(fieldId, displayNum);
      updateCriteriaByColumn('functionType', displayNum, functionType);
    }
    // use the default type to render the other components
    this.handleValueTypeChange(UserInput, displayNum);
  }

  handleValueTypeChange = (valueType, displayNum) => {
    const { updateCriteriaByColumn } = this.props;
    updateCriteriaByColumn('valueType', displayNum, valueType);
    this.handleValueChange(displayNum, '');
    this.hadleSiderClose();
  }

  handleValueChange = (displayNum, value) => {
    const { updateCriteriaByColumn } = this.props;
    updateCriteriaByColumn('value', displayNum, value);
  }

  hadleSiderClose = () => {
    const { resetSiderData, resetWidth, toggleRightSider } = this.props;
    resetWidth('right');
    toggleRightSider(true);
    resetSiderData();
  }

  render() {
    const {
      logic,
      criteria,
      metaFields,
      conditions,
      functionOptions,
      rightSiderValue,
      setCriteriaLogic,
      addCriteria,
    } = this.props;

    const valueTypeOptions = [
      {
        id: UserInput,
        display_value: 'User Input',
      },
      {
        id: FunctionName,
        display_value: 'Function',
      },
      {
        id: ContextAttributes,
        display_value: 'Compare',
      }
    ];

    return (
      <FilterCriteria
        fields={metaFields}
        logicText={logic}
        filters={criteria}
        conditions={conditions}
        valueTypeOptions={valueTypeOptions}
        functionOptions={functionOptions}
        rightSiderValue={rightSiderValue}
        getCompareOptions={this.getCompareOptions}
        hadleSiderClose={this.hadleSiderClose}
        handleAddNewClick={addCriteria}
        handleAddonClick={this.handleAddonClick}
        handleFilterRemove={this.handleRemove}
        handleFieldChange={this.handleFieldChange}
        handleConditionChange={this.handleConditionChange}
        handleValueTypeChange={this.handleValueTypeChange}
        handleValueChange={this.handleValueChange}
        handleLogicChange={value => setCriteriaLogic(value)}
      />
    );
  }
}

const mapStateToProps = ({ ui, global, setup }) => {
  const { workFlowCriteria, metaData } = setup.workFlow;
  const config = getConfigByMeta(metaData);
  return {
    lang: global.language,
    logic: workFlowCriteria.criteriaLogic,
    criteria: workFlowCriteria.criteria,
    metaFields: metaData.criteriaMetaData.fields,
    metaConditions: metaData.criteriaMetaData.conditions,
    conditions: config.conditions,
    functionOptions: config.paramOptions,
    rightSiderValue: metaData.sider,
    collapsed: ui.rightSider.collapsed,
  };
};
const mapDispatchToProps = {
  setCriteriaLogic,
  addCriteria,
  removeCriteria,
  updateCriteriaByColumn,
  toggleRightSider,
  resetWidth,
  setWidth,
  fetchRightSideData,
  setSiderData,
  resetSiderData
};

WorkFlowCriteria.propTypes = propTypes;
WorkFlowCriteria.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(WorkFlowCriteria);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/WorkFlowCriteria.jsx